import { classNames } from "@frec-js/common-web";
import { FC } from "react";
import { PiCalendarBlank } from "react-icons/pi";

import { PostType } from "../utils/blogApi";

export const BlogMetaDate: FC<{
  post: PostType;
  className?: string;
  showUpdated?: boolean;
}> = ({ post, className, showUpdated = true }) => {
  const dateToUse = showUpdated ? post.modified : post.date;
  return (
    <time
      dateTime={post.date} // this is just metadata for machine reading; using date of publish
      className={classNames("flex items-center gap-2", className)}
    >
      <PiCalendarBlank size={20} className="inline" />{" "}
      {showUpdated && `Updated `}
      {/* Actual date to display */}
      {new Date(dateToUse).toLocaleDateString("en-us", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })}
    </time>
  );
};
